import { Alert } from "antd";
import React, { JSX, ReactNode } from "react";
import { useHistory, useParams } from 'react-router-dom';
import { DOWNLOAD_AUTH } from "../../routes";
 

export interface DownloadErrorProps {
  missingEToursOnly: string
  msg: string
  content?: ReactNode
}

const MSG = {
  '400-001': 'Bad key. Please check the links validity & try again.',
  '400-002': 'Bad download request. Please check the links validity & try again.',
  '404-001':
    'Order not found. Please check the links validity, tours download expiration date & try again.',
  '404-002':
    'No Tour Reports are found for the current order. Please check the links validity, tours download expiration date & try again.',
  '404-003':
    'No Tour Reports are found for download. Please check the links validity, tours download expiration date & try again.',
}

const DownloadError = (props: DownloadErrorProps): JSX.Element => {
  const history = useHistory()
  const { disseminationKey }: { disseminationKey: string } = useParams()

  const { missingEToursOnly, msg } = props

  if ((msg ?? '').startsWith('401')) {
    history.push(DOWNLOAD_AUTH + disseminationKey + `?missingEToursOnly=${missingEToursOnly}`)
  }

  // @ts-ignore
  let desc = MSG[msg]
  if (desc == null) {
    desc = 'Unknown error!'
  }
  return (
    <div>
      <Alert
        message="Tour Reports Error!"
        description={
          <div>
            <p>{desc}</p>
            <p style={{ fontSize: '80%' }}>({msg})</p>
          </div>
        }
        type="error"
        showIcon={true}
      />
    </div>
  )
}

export default DownloadError;
